import React from 'react';

import { NO_SCROLL_ID } from '../../../../config/constants';

import * as S from './styles';

// Types

type Props = {
  name: string;
  className?: string;
};

const SectionItemStoreLocatorName = ({ className, name }: Props) => {
  return (
    <S.Wrapper className={className} contentPositionY="left" id={NO_SCROLL_ID} isSectionContentExtraWide={false} sectionWidth={100}>
      <S.Name id={NO_SCROLL_ID}>{name}</S.Name>
    </S.Wrapper>
  );
};

export default SectionItemStoreLocatorName;
